"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_EVENTS = void 0;
exports.EMPTY_EVENTS = {
    commitmentEvents: [],
    unshieldEvents: [],
    nullifierEvents: [],
};
